import React from "react";

const LandPage = () => {
  return (
    <div
      style={{ maxWidth: "1440px",height:"500px", display: "flex", flexDirection: "column", textAlign: "center" }}
    >
      <h1 style={{ paddingTop:"40px",textAlign: "center" }}>Welcome to DAM Journey LLC</h1>
      <br />
    </div>
  );
};
export default LandPage;
